// src/pages/Home.jsx
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom"; // ✅ استيراد للتوجيه
import { useDispatch, useSelector } from "react-redux";

import InfoBar from "../features/InfoBar";
import CriteriaBar from "../features/CriteriaBar";
import EvaluationsForStudents from "../features/EvaluationsForStudents";
import { hydrateLessonsFromStorage } from "../store";

import students from "../data/students.json";
import subjects from "../data/subjects.json";
import {
  loadStudents,
  selectEvaluations,
  selectLessons,
  selectInfo,
} from "../store";

// ✅ استيراد مكونات الأيقونات والـ Material UI لزر الخروج
import { PageContainer, VList } from "../utils/layouts";

// تحويل subject (قد تكون اسم أو id) إلى اسم موحد
const normalizeSubjectName = (raw) => {
  if (raw == null || raw === "") return "";
  const n = Number(raw);
  if (Number.isFinite(n) && n > 0) {
    return subjects.find((s) => Number(s.id) === n)?.name ?? "";
  }
  return String(raw).trim();
};

// هل الطالب "مُقَيَّم" في هذا الدرس؟ (مرة واحدة على الأقل داخل ratingsByAxis)
const isStudentRatedInLesson = (st) => {
  const r = st?.ratingsByAxis || {};
  if (!r || typeof r !== "object") return false;
  return Object.values(r).some((v) => String(v || "").trim() !== "");
};

const Home = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate(); // ✅ تهيئة التوجيه

  const lessons = useSelector(selectLessons);
  const evaluations = useSelector(selectEvaluations);
  const info = useSelector(selectInfo);

  const [scannedData, setScannedData] = useState(null);

  // جلب البيانات من Local Storage عند تحميل الصفحة
  useEffect(() => {
    const data = localStorage.getItem('scannedQRData');
    if (data) {
      setScannedData(data);
    }
  }, []);

  // المادة المختارة (اسم موحد)
  const selectedSubjectName = React.useMemo(
    () => normalizeSubjectName(info?.subject),
    [info?.subject]
  );

  // لا تعيد تحميل الطلاب إذا موجودين (حتى لا تضيع الحالة)
  React.useEffect(() => {
    if (!evaluations || evaluations.length === 0) {
      dispatch(loadStudents(students));
    }
  }, [dispatch, evaluations?.length]);

  React.useEffect(() => {
    dispatch(hydrateLessonsFromStorage());
  }, [dispatch]);

  // فلترة الدروس حسب المادة المختارة فقط
  const filteredLessons = React.useMemo(() => {
    const list = Array.isArray(lessons) ? lessons : [];
    if (!selectedSubjectName) return [];
    return list.filter((ls) => {
      const lessonSubjectName = normalizeSubjectName(ls?.info?.subject);
      return lessonSubjectName && lessonSubjectName === selectedSubjectName;
    });
  }, [lessons, selectedSubjectName]);

  // الطلاب الذين تم تقييمهم مرة واحدة على الأقل عبر جميع دروس المادة المحددة
  const ratedStudentIds = React.useMemo(() => {
    const set = new Set();
    for (const lesson of filteredLessons) {
      const sts = lesson?.students || [];
      for (const st of sts) {
        if (!st?.id) continue;
        if (isStudentRatedInLesson(st)) {
          set.add(String(st.id));
        }
      }
    }
    return set;
  }, [filteredLessons]);



  return (
    <PageContainer >
      
      {/* ✅ زر الخروج العائم */}
      <VList>
        <InfoBar />
      <CriteriaBar />
      <EvaluationsForStudents />
      </VList>
    </PageContainer>
  );
};

export default Home;